import { useMutation } from '@tanstack/react-query';
import { sendFile } from 'config/requests';
import { queryClient } from 'providers/queryClient';

import { UPLOAD_FILES } from './useGetFiles';

export function useSendFile() {
  const mutation = useMutation({
    mutationFn: (data: FormData) => sendFile(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UPLOAD_FILES] }),
  });
  return { sendFile: mutation };
}
